import { useDesign, useSite } from "../context/SiteContext";
import { NewsFeed } from "../components/NewsFeed";
import { ClassicHome, MinimalHome, ResortHome } from "./home/layoutsA";
import { BoutiqueHome, SafariHome } from "./home/layoutsB";

const LAYOUTS = { classic: ClassicHome, minimal: MinimalHome, resort: ResortHome, boutique: BoutiqueHome, safari: SafariHome };

export default function Home() {
  const data = useSite();
  const design = useDesign();
  const Layout = LAYOUTS[design];
  const scrollUp = () => window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <div data-testid="home-page" data-design-layout={design}>
      <Layout data={data} />
      {data.news.length > 0 && <NewsFeed items={data.news} onSelect={scrollUp} />}
    </div>
  );
}
